// Conversion barres ↔ kg du fer à béton (même logique que server/services/fer.js).
// Le tableau (kg par barre, par diamètre et origine) vient de Paramètres ; il est chargé une fois puis gardé en mémoire.
import { useEffect, useState } from 'react';
import { settingsAPI } from '../services/api';

let TABLE = null;
let enCours = null;
const abonnes = new Set();

export function chargerFer(force = false) {
  if (TABLE && !force) return Promise.resolve(TABLE);
  if (!enCours || force) {
    enCours = settingsAPI.fer().then((r) => { TABLE = r.data.table; abonnes.forEach((f) => f(TABLE)); return TABLE; })
      .catch(() => null).finally(() => { enCours = null; });
  }
  return enCours;
}
export const tableFer = () => TABLE;
export function definirTableFer(t) { TABLE = t; abonnes.forEach((f) => f(TABLE)); }

/** Tableau des poids (recharge l'écran quand il arrive). */
export function useFer() {
  const [t, setT] = useState(TABLE);
  useEffect(() => {
    abonnes.add(setT);
    chargerFer().then((x) => x && setT(x));
    return () => abonnes.delete(setT);
  }, []);
  return t;
}

/** « Fer12L », « FER12 », origine → { d, o } ; null si ce n'est pas du fer. */
export function identifierFer(cle, origine) {
  const m = /^fer\s*(\d+)\s*(l)?$/i.exec(String(cle || '').trim());
  if (!m) return null;
  return { d: Number(m[1]), o: m[2] || origine === 'LOCAL' ? 'LOCAL' : 'IMPORTE' };
}

export function kgParBarre(cle, origine, t = TABLE) {
  const id = identifierFer(cle, origine);
  if (!id || !t?.[id.d]) return null;
  // à défaut, l'autre origine du même diamètre (anciennes saisies)
  return t[id.d][id.o] || t[id.d][id.o === 'LOCAL' ? 'IMPORTE' : 'LOCAL'] || null;
}

/** « 500 + 7 barres », « 1t+550kg+5 barres », « 0,5 » (unité par défaut) → { masseKg, barres } ou null. */
export function lireFer(texte, unite = 'kg') {
  const s = String(texte ?? '').toLowerCase().replace(/,/g, '.').replace(/\s+/g, ' ').trim();
  if (!s) return null;
  const facteur = { t: 1000, kg: 1, g: 0.001 };
  let masseKg = 0; let barres = 0; let ok = false;
  const re = /(\d+(?:\.\d+)?)\s*(tonnes?|t|kg|kilos?|g|barres?|b)?/g;
  let m;
  while ((m = re.exec(s))) {
    const n = Number(m[1]); const u = m[2] || '';
    ok = true;
    if (/^b/.test(u)) barres += n;
    else if (/^(t|tonne)/.test(u)) masseKg += n * 1000;
    else if (/^(kg|kilo)/.test(u)) masseKg += n;
    else if (u === 'g') masseKg += n / 1000;
    else masseKg += n * (facteur[unite] ?? 1);
  }
  return ok ? { masseKg: Math.round(masseKg * 1000) / 1000, barres } : null;
}

/** Poids total en kg ; null si des barres sans poids connu. */
export function ferEnKg(texte, unite, cle, origine, t = TABLE) {
  const q = lireFer(texte, unite);
  if (!q) return null;
  if (!q.barres) return q.masseKg;
  const k = kgParBarre(cle, origine, t);
  return k ? Math.round((q.masseKg + q.barres * k) * 10) / 10 : null;
}

export const kgFr = (n) => `${Number(n).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} kg`;
/** Nombre de barres équivalent (arrondi à 0,1). */
export const enBarres = (kg, kpb) => (kpb ? Math.round((Number(kg) / kpb) * 10) / 10 : null);
